module.exports = __webpack_public_path__ + "media/images/pic/teachers/animation-761bac63eadae764ceaff114115bd1de.svg";